import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import BemClass from '@upsales/components/Utils/bemClass';
import { RootState } from 'Store/index';
import { resolveUserMentions } from 'Components/Mentions/MentionsInput/mentionUtils';
import { renderUserMarkdown, flattenStoredHtml, MENTION_CLASS } from 'Helpers/markdown';
import './CommentText.scss';

type Props = {
	text: string;
	className?: string;
	onClick?: React.MouseEventHandler<HTMLDivElement>;
};

const CommentText = React.forwardRef<HTMLDivElement, Props>(({ text, className, onClick }, ref) => {
	const users = useSelector((state: RootState) => state.App.userMap.active);
	const classes = new BemClass('CommentText', className);
	const html = useMemo(() => {
		const normalized = flattenStoredHtml(text);
		const withMentions = resolveUserMentions(
			normalized,
			users,
			name => `<span class="${MENTION_CLASS}">@${name}</span>`
		);
		// An unresolved tag would otherwise read as markdown emphasis: @__user$1__ renders bold
		const escaped = withMentions.replace(/@__user\$\d+__/g, tag => tag.replace(/_/g, '\\_'));
		return renderUserMarkdown(escaped);
	}, [text, users]);

	return <div ref={ref} className={classes.b()} onClick={onClick} dangerouslySetInnerHTML={{ __html: html }} />;
});

export default CommentText;
